import { InvoiceState } from './invoiceState.enum.model';

export class ChartCompanyInvoiceStatusSummaryItem{
    public quantity : number;
    public total : number;
}